import { render } from "./modificadores.vue?vue&type=template&id=33b82e06"
import script from "./modificadores.vue?vue&type=script&lang=js"
export * from "./modificadores.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Users\\felipecedillo\\Documents\\GitHub\\marbel-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__